import {DEFAULT_TAX_ACCOUNTANT_NAME, TaxAccountantNameModel} from "@/shared/model";
import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "../../tax-corporation";

const schema = z.object({
	taxAccountantName: TaxAccountantNameModel.model,
	recommendedCustomerName: ManagerInformationModel.model
});

const model = schema.transform((values) => ({
	...values
}));

export const CustomerRecommendationModel = {schema, model};
export type ICustomerRecommendationModel = z.infer<typeof CustomerRecommendationModel.model>;
export const DEFAULT_CUSTOMER_RECOMMENDATION: ICustomerRecommendationModel = {
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	recommendedCustomerName: DEFAULT_MANAGER_INFORMATION
};
